module.exports = __webpack_public_path__ + "static/media/TemplateSparePart.e91c93c7.xlsx";